Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = mutuallyInclusive;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function mutuallyInclusive(propMapping) {
  return Object.keys(propMapping).reduce(function (propTypes, prop) {
    return Object.assign({}, propTypes, _defineProperty({}, prop, function () {
      function validator(props, propName, componentName) {
        // This prop wasn't present, so don't worry about checking other props
        if (typeof props[propName] === 'undefined' || props[propName] === null) {
          return null;
        }

        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }

        var currentPropResult = propMapping[prop].apply(propMapping, [props, propName, componentName].concat(rest));
        if (currentPropResult) {
          return currentPropResult;
        }

        var otherProps = Object.assign({}, propMapping);
        delete otherProps[prop];
        var missingProps = Object.keys(otherProps).reduce(function (sum, p) {
          if (typeof props[p] !== 'undefined' && props[p] !== null) {
            return sum;
          }
          return [].concat(_toConsumableArray(sum), [p]);
        }, []);

        if (missingProps.length === 0) {
          return null;
        }

        return new TypeError(String(componentName) + ': when `' + String(prop) + '` is present, props ' + String(missingProps.map(function (p) {
          return '`' + String(p) + '`';
        }).join(', ')) + ' must also be present.');
      }

      return validator;
    }()));
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/mutuallyInclusive.js
// module id = 448
// module chunks = 923280921217